// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n/* The wrapper is the single scroll container; let the inner paginated lists grow\n   naturally so we don't get a nested/double scrollbar that hides the bottom items. */\n[id=\"#streams-widget-wrapper\"][data-v-aacc2772] .paginated-list > ul {\n  max-height: none;\n  overflow: visible;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
